import Repository from "../Repository";
export default {
  getAll: () => {
    return Repository.get('/notification-message-templates');
  },

  getList: (params) => {
    return Repository.get('/notification-message-templates/list', { params });
  },

  get: (id) => {
    return Repository.get(`/notification-message-templates/${id}`);
  },

  update: (id, payload) => {
    return Repository.put(`/notification-message-templates/${id}`, payload);
  },

  batchUpdate(payload) {
    return Repository.post('/notification-message-templates/batch-update', payload);
  },

  create(payload) {
    return Repository.post('/notification-message-templates', payload);
  },

  delete(id) {
    return Repository.delete(`/notification-message-templates/${id}`);
  }
};
